"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitAbsenceRequestApiPayloadSchema = void 0;
const zod_1 = require("zod");
const absence_enums_1 = require("./absence-enums");
exports.submitAbsenceRequestApiPayloadSchema = zod_1.z.object({
    type: absence_enums_1.absenceTypeSchema,
    fromDate: zod_1.z.string().date(),
    toDate: zod_1.z.string().date(),
    reason: zod_1.z.string().trim().min(1).optional(),
});
